import { useEffect, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  crumb: string;
  eyebrow: string;
  title: string;
  docTitle: string;
  children?: ReactNode;
}

export default function PageIntro({ crumb, eyebrow, title, docTitle, children }: Props) {
  useEffect(() => {
    document.title = docTitle;
  }, [docTitle]);

  return (
    <div className="max-w-[1200px] mx-auto px-5 md:px-10 pt-12 md:pt-20 pb-16 md:pb-24">
      <nav aria-label="Breadcrumb" className="font-label text-xs tracking-[0.08em] text-foreground-500">
        <Link to="/" className="cursor-pointer hover:text-primary-500">Home</Link>
        <span className="mx-2">/</span>
        <span className="text-foreground-950">{crumb}</span>
      </nav>
      <header className="mt-10 md:mt-14">
        <p className="eyebrow text-primary-500">{eyebrow}</p>
        <h1 data-mo="title" data-mo-now className="mt-5 h-section text-foreground-950 max-w-4xl">{title}</h1>
        {children && <div data-mo="fade" data-mo-now className="mt-6 t-body text-foreground-600 max-w-xl">{children}</div>}
      </header>
    </div>
  );
}